import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button, useMediaQuery } from "@mui/material";
import Gates from "./gates";
import Transactions from "./transactions";
import Employees from "./employees";
import Services from "./services";
import CustomTabPanel, {
  a11yProps,
} from "src/shared/components/custom-tab-panel";

const LocationProfileTabs = () => {
  const [value, setValue] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:700px)");
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          orientation={isSmallScreen ? "vertical" : "horizontal"}
          sx={{
            minHeight: { xs: "100%", md: "44px" },
            height: { xs: "100%", md: "44px" },
            bgcolor: "#232323",
            borderRadius: "10px",
          }}
        >
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Gates"}
            {...a11yProps(0)}
          />
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Services"}
            {...a11yProps(1)}
          />
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Transactions"}
            {...a11yProps(2)}
          />
          <Tab
            disableRipple
            sx={{
              color: "#FFFFFF",
              height: "44px",
              minHeight: "44px",
              textTransform: "unset",
              "&.Mui-selected": {
                bgcolor: "#CC9C33",
                color: "#000000",
                borderRadius: "9px",
                fontWeight: 600,
              },
            }}
            label={"Employees"}
            {...a11yProps(3)}
          />
        </Tabs>
        <Button variant="outlined" size="medium">
          Archive
        </Button>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Gates />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Services />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Transactions />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Employees />
      </CustomTabPanel>
    </Box>
  );
};

export default LocationProfileTabs;
